import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './mapy-loader3.js';
import { E as getStructuredReviewData, F as getStarsFromStructuredItems, g as getLocale, z as classNames, k as getTheme } from './utils2.js';
import { d as DIALOG_PAGES, e as STRUCTURED_MEDIAN, j as STARS_SIZE } from './const.js';
import { d as defineCustomElement$a } from './mapy-icon2.js';
import { d as defineCustomElement$9 } from './mapy-loader2.js';
import { d as defineCustomElement$8 } from './mapy-review-button2.js';
import { d as defineCustomElement$7 } from './mapy-review-dialog-footer2.js';
import { d as defineCustomElement$6 } from './mapy-review-stars2.js';
import { d as defineCustomElement$5 } from './mapy-review-structured-review2.js';
import { d as defineCustomElement$4 } from './mapy-review-structured-review-item2.js';
import { d as defineCustomElement$3 } from './mapy-review-tooltip2.js';
import { d as defineCustomElement$2 } from './mapy-review-user2.js';

const mapyReviewDialogPageStarsStructuredCss = ".mapy-review-dialog-page-stars-structured{padding:48px 32px 0 32px;display:flex;flex-direction:column;gap:24px;justify-content:space-between;height:100%;box-sizing:border-box;font-family:Arial;align-items:center;position:relative}.header{display:flex;gap:8px;flex-direction:column;align-items:center;justify-content:center;width:100%}.header .title{margin:0;font-size:20px;font-style:normal;font-weight:700;line-height:28px}.structuredReview{display:flex;width:100%;padding:0 16px;box-sizing:border-box}.structuredReview mapy-review-structured-review{width:100%;flex:1}.stars-area.has-loader{position:relative}.stars-area .areaLoader{position:absolute;left:50%;transform:translateX(-50%);margin-top:8px}mapy-review-dialog-footer{width:100%}.mapy-review-dialog-page-stars-structured[data-theme=\"firmy\"] .structuredReview{flex:0 1 auto}@media only screen and (max-height: 529px){.mapy-review-dialog-page-stars-structured{overflow:auto}}@media only screen and (max-width: 500px){.mapy-review-dialog-page-stars-structured{padding:24px 16px 0 16px}.structuredReview{padding:0}}";
const MapyReviewDialogPageStarsStructuredStyle0 = mapyReviewDialogPageStarsStructuredCss;

var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MapyReviewDialogPageStarsStructured_structuredData, _MapyReviewDialogPageStarsStructured_wasStarsClick, _MapyReviewDialogPageStarsStructured_lang;
defineCustomElement$1();
const MapyReviewDialogPageStarsStructured = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogPageStarsStructured extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.save = createEvent(this, "save", 1);
        _MapyReviewDialogPageStarsStructured_structuredData.set(this, []);
        _MapyReviewDialogPageStarsStructured_wasStarsClick.set(this, false);
        _MapyReviewDialogPageStarsStructured_lang.set(this, "");
        this.onStarsChange = (event) => {
            event.stopPropagation();
            __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_wasStarsClick, true, "f");
            // @ts-ignore
            this.curRating = event.target.value;
            this.signal.emit({
                name: "stars-click",
                rating: this.curRating,
            });
            if (!this.hasButton) {
                this.onSave();
            }
        };
        this.onSignal = (signal) => {
            this.signal.emit(signal.detail);
        };
        this.onFooterSave = () => {
            this.onSave();
        };
        this.onSave = () => {
            let structuredRating = [];
            if (this.structuredItems.length > 0) {
                structuredRating = __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f").length > 0
                    ? __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f")
                    : getStructuredReviewData(this.structuredItems);
            }
            this.save.emit({
                page: DIALOG_PAGES.STARS_STRUCTURED,
                rating: this.curRating,
                structuredRating,
            });
        };
        this.onStructuredItemsChange = (event) => {
            __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_structuredData, event.detail.items, "f");
            this.signal.emit({
                name: "structured-review",
                data: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f"),
            });
            if (!__classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_wasStarsClick, "f")) {
                this.curRating = getStarsFromStructuredItems(this.structuredMedian, __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f"));
            }
        };
        this.user = "";
        this.verifiedUser = false;
        this.poiTitle = "";
        this.isFirm = false;
        this.hasButton = false;
        this.rating = 0;
        this.error = "";
        this.loading = false;
        this.switchStars = false;
        this.structuredMedian = STRUCTURED_MEDIAN;
        this.structuredItems = [];
        this.service = "mapy";
        this.isResponsive = false;
        this.curRating = this.rating;
    }
    onRatingChange(rating) {
        this.curRating = rating;
    }
    componentWillLoad() {
        __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_lang, getLocale(this.hostElement), "f");
        this.curRating = this.rating;
        __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_wasStarsClick, this.rating > 0, "f");
    }
    render() {
        const starsArea = h("div", { key: 'cae1a6e1917038694297b83aaa83b8f62b3801a9', class: classNames(["stars-area", this.hasButton && this.loading ? "has-loader" : ""]) }, h("mapy-review-stars", { key: '5d83495c6e4532deb1267a67a45bf838e06d27b8', value: this.curRating, size: this.isResponsive ? STARS_SIZE.responsive : STARS_SIZE.normal, onInput: this.onStarsChange, gap: 13, disabled: this.loading }), !this.hasButton && this.loading && h("div", { class: "areaLoader" }, h("mapy-loader", null)));
        const structuredArea = this.structuredItems.length > 0 && h("div", { key: '7691fa0608529601ca3b163a1b2caafd2513c043', class: "structuredReview" }, h("mapy-review-structured-review", { key: '78a62cf6d701bdd64ffe07c58f8ac1006bb7d462', items: this.structuredItems, onChange: this.onStructuredItemsChange, tooltip: true, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_lang, "f") }));
        return h(Host, { key: '473c9e4a9c2f36d1a3fdaebb3c9d466074e1e809' }, h("div", { key: 'c184d5a83288c8c993701965396e0f237590fe22', class: "mapy-review-dialog-page-stars-structured", "data-theme": getTheme(this.service) }, h("div", { key: 'cb4d08248b1bbd3fc8cc519b0de3ead6b90e11d7', class: "header" }, h("h3", { key: 'd46073a5b7c20556d0238992c633a20680a2355d', class: "title" }, this.poiTitle), h("mapy-review-user", { key: 'a616277c5f8bd11808c2be7c939b1e73dee95177', user: this.user, verifiedUser: this.verifiedUser, onSignal: this.onSignal, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_lang, "f") })), this.switchStars ? starsArea : structuredArea, this.switchStars ? structuredArea : starsArea, h("mapy-review-dialog-footer", { key: '0b3d5edc1c367ba1ea35f1ce009659eaee57c561', isFirm: this.isFirm, hasButton: this.hasButton, loading: this.hasButton && this.loading, disabled: this.curRating === 0 || this.loading, onSave: this.onFooterSave, onSignal: this.onSignal, error: this.error, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_lang, "f"), service: this.service })));
    }
    get hostElement() { return this; }
    static get watchers() { return {
        "rating": ["onRatingChange"]
    }; }
    static get style() { return MapyReviewDialogPageStarsStructuredStyle0; }
}, [1, "mapy-review-dialog-page-stars-structured", {
        "user": [513],
        "verifiedUser": [516, "verified-user"],
        "poiTitle": [513, "poi-title"],
        "isFirm": [516, "is-firm"],
        "hasButton": [516, "has-button"],
        "rating": [514],
        "error": [513],
        "loading": [516],
        "switchStars": [516, "switch-stars"],
        "structuredMedian": [514, "structured-median"],
        "structuredItems": [16],
        "service": [513],
        "isResponsive": [516, "is-responsive"],
        "curRating": [32]
    }, undefined, {
        "rating": ["onRatingChange"]
    }]);
_MapyReviewDialogPageStarsStructured_structuredData = new WeakMap(), _MapyReviewDialogPageStarsStructured_wasStarsClick = new WeakMap(), _MapyReviewDialogPageStarsStructured_lang = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-page-stars-structured", "mapy-icon", "mapy-loader", "mapy-review-button", "mapy-review-dialog-footer", "mapy-review-stars", "mapy-review-structured-review", "mapy-review-structured-review-item", "mapy-review-tooltip", "mapy-review-user"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-page-stars-structured":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogPageStarsStructured);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "mapy-review-structured-review":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "mapy-review-structured-review-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "mapy-review-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-user":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogPageStarsStructured as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-page-stars-structured2.js.map